/** Inline select dropdown */
export function InlineSelectField({
  label,
  value,
  onChange,
  options,
  show,
}: {
  label: string
  value: string
  onChange: (value: string) => void
  options: { label: string; value: string }[]
  show: boolean
}) {
  if (!show) return null

  return (
    <div className="flex justify-between items-center gap-2">
      <span className="text-muted-foreground text-xs shrink-0">{label}</span>
      <select
        className="flex-1 min-w-0 h-7 max-w-[160px] rounded border border-input bg-background px-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-ring"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`select-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <option value="">--</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  )
}
